import React from 'react';
import './index.scss';

const SkipToContentLink = ({ target = 'MainContent', text = 'Skip to main content' }) => (
  <a className="SkipToContentLink" href={'#' + target}>{text}</a>
);

export default SkipToContentLink;
